import React from "react";
import ProfileBox from "../components/Box/ProfileBox";
import WalletList from "../components/Box/WalletList";
import { MdOutlinePayment } from "react-icons/md";
import { MdOutlineNoteAlt } from "react-icons/md";
import Navbar from "./Navbar";
import { BiWalletAlt } from "react-icons/bi";
import useAuth from "../hooks/useAuth";
const ApnamartWallet = () => {
  const { user } = useAuth();

  return (
    <>
      <Navbar />
      <div className="lg:px-12 md:px-8 px-0 w-full lg:py-5 md:py-4 py-2 bg-slate-50">
        <h1 className="text-xl font-bold md:px-8 px-4 py-4">Apna App Wallet</h1>
        <div className="flex flex-col md:flex-row w-full justify-evenly">
          <div className="basis-5/12 ">
            <div className="mb-4 w-full border">
              <ProfileBox user={user} />
            </div>
            <div className="hidden md:block border bg-white">
              <WalletList />
            </div>
          </div>

          <div className="w-full md:basis-6/12">
            <div className="grid grid-cols-2 bg-white mb-4 border py-10">
              <a href="/wallet" className="block">
                <div className="flex justify-center flex-col items-center">
                  <MdOutlinePayment className="text-3xl text-rose-500 mb-2" />
                  <h1 className="text-center font-semibold text-xs ">
                    Payment Methods
                  </h1>
                </div>
              </a>
              <a href="/wallet">
                <div className="flex justify-center flex-col items-center">
                  <MdOutlineNoteAlt className="text-3xl text-rose-500 mb-2" />
                  <h1 className="text-center font-semibold text-xs ">Orders</h1>
                </div>
              </a>
            </div>

            <div className="flex flex-wrap w-full ">
              <div className="relative p-2 mb-4 w-full md:basis-7/12 bg-white pb-5 border rounded-md">
                <div className="absolute w-12 h-12 rounded-full grid place-content-center  top-2 right-2 bg-green-100 ">
                  <BiWalletAlt className="text-green-500 text-3xl" />
                </div>

                <h1 className="text-md font-semibold py-1">Apna Mart Wallet</h1>
                <h1 className="text-2xl font-bold py-1">₹0.00</h1>
              </div>

              <div className="relative p-2 w-full md:basis-7/12 bg-white pb-5 border rounded-md">
                <h1 className="text-md font-semibold py-1">
                  Apna Mart Gift Card
                </h1>
                <h1 className="text-2xl font-bold py-1">₹0.00</h1>
                <p className="text-xs text-gray-400 font-semibold mb-2">
                  Redeem your Gift Card Balance across eligible JioMart products
                  and Reliance stores.
                </p>
                <button className="pt-2.5 w-full text-center text-sm text-sky-400 border border-transparent border-t-gray-200">
                  View Details
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApnamartWallet;
